module.exports = __webpack_public_path__ + "static/img/banner_02.d21fb8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/common/images/banner_02.png
// module id = dy9k
// module chunks = 1